import { reducer as formsReducer } from './forms.slice';

export default formsReducer;
